import { Schema } from "effect";
import { KVTarget } from "../../api/kv/model.ts";
import type { KVBindingRecord, KVEntry, KVTarget as Target } from "../../api/kv/model.ts";

export const KVAction = Schema.Union([
  Schema.TaggedStruct("SelectWorkspace", { workspaceId: Schema.NullOr(Schema.String), refreshToken: Schema.optionalKey(Schema.Number) }),
  Schema.TaggedStruct("SelectTarget", { target: KVTarget }),
  Schema.TaggedStruct("Refresh", {}),
  Schema.TaggedStruct("Search", { prefix: Schema.String }),
  Schema.TaggedStruct("LoadMore", {}),
  Schema.TaggedStruct("Add", { key: Schema.String, value: Schema.String }),
  Schema.TaggedStruct("Edit", { originalKey: Schema.String, key: Schema.String, value: Schema.String }),
  Schema.TaggedStruct("AskDelete", { key: Schema.String }),
  Schema.TaggedStruct("ConfirmDelete", {}),
  Schema.TaggedStruct("CloseDelete", {}),
  Schema.TaggedStruct("ConfirmOverwrite", {}),
  Schema.TaggedStruct("CloseOverwrite", {})
]);
export type KVAction = typeof KVAction.Type;
export const KVSettlement = Schema.Struct({ target: KVTarget, operation: Schema.Literals(["add", "edit", "delete"]), key: Schema.String, originalKey: Schema.optionalKey(Schema.String), outcome: Schema.Literals(["success", "refused", "confirmation"]), progress: Schema.Literals(["checked", "uncertain", "written", "complete"]), message: Schema.NullOr(Schema.String) });
export type KVSettlement = typeof KVSettlement.Type;
export const KVOverwrite = Schema.Struct({ key: Schema.String, value: Schema.String, originalKey: Schema.optionalKey(Schema.String) });
export type KVOverwrite = typeof KVOverwrite.Type;
export interface KVSnapshot {
  readonly workspaceId: string | null;
  readonly target: Target | null;
  readonly bindings: readonly KVBindingRecord[];
  readonly entries: readonly KVEntry[];
  readonly cursor: string | null;
  readonly prefix: string | undefined;
  readonly error: string | null;
  readonly loadingBindings: boolean;
  readonly loading: boolean;
  readonly loadingMore: boolean;
  readonly mutating: boolean;
  readonly savingAdd: boolean;
  readonly savingEdit: boolean;
  readonly deleting: boolean;
  readonly overwriting: boolean;
  readonly deleteTarget: string | null;
  readonly overwriteConfirm: KVOverwrite | null;
  readonly clearAddForm: number;
  readonly clearEditForm: number;
}
export const emptyKV = (workspaceId: string | null = null, target: Target | null = null, mutating = false): KVSnapshot => ({ workspaceId, target, bindings: [], entries: [], cursor: null, prefix: undefined, error: null, loadingBindings: false, loading: target !== null, loadingMore: false, mutating, savingAdd: false, savingEdit: false, deleting: false, overwriting: false, deleteTarget: null, overwriteConfirm: null, clearAddForm: 0, clearEditForm: 0 });
